import { store, observable, loading } from '~/common/mobx.decorator'
import { action, computed } from 'mobx'
import { CollectionCursorStore } from '~/stores/collection.cursor.store'
import { GET_SELECT_OPTIONS } from '~/common/apollo/queries/select-option.query'

@store()
class SelectOptionStore extends CollectionCursorStore {
	@observable dataType = null

	constructor(dataType) {
		super(GET_SELECT_OPTIONS, 'selectOptions', ['totalCount'])
		this.name = 'SelectOptionStore'
		this.dataType = dataType
	}

	@computed
	get dataSource() {
		return this.list.map((item) => ({
			label: item.name,
			value: item.id,
		}))
	}

	@loading
	@action
	fetchData = (isReload) => {
		return this.load(isReload, {
			filter: {
				dataType: this.dataType,
			},
			first: undefined,
			after: undefined,
		})
	}

	@action
	setKeyword = () => { }

	@action
	checkExist = async () => { }

	@action
	reset = () => {
		this.reset()
		this.dataType = null
	}
}

export const selectOptionStore = new SelectOptionStore()
export const countriesSelectOptionStore = new SelectOptionStore('countries')
export { SelectOptionStore }
